import axios from './config/config-viva'

const defaultRoute = 'especialidades/'

export default {
    list: () => {
        return axios.get(`${defaultRoute}`)
    },
    findById: (id) => axios.get(defaultRoute+id),
    create: (especialidade) => {
        return axios.post(defaultRoute, especialidade)
    },
    update: (id, especialidade) => {
        return axios.put(defaultRoute+id, especialidade)
    },
    remove: (id) => {
        return axios.delete(defaultRoute+id)
    }
}